import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CheckCircleOutlined, CloseCircleOutlined, LoadingOutlined } from '@ant-design/icons';
import {
  PaymentStatusWrapper,
  StatusIcon,
  StatusTitle,
  StatusMessage,
  ErrorDetails,
  ActionButton,
} from './PaymentStatus.styles';
import { checkPaymentStatus } from '../../../config/api/payment';

function PaymentStatus() {
  const navigate = useNavigate();
  const location = useLocation();
  const [status, setStatus] = useState('processing');
  const [message, setMessage] = useState('Processing your payment...');
  const [error, setError] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const urlPaymentMethod = params.get('payment_method');
    const urlPaymentStatus = params.get('payment_status');
    const transactionId = params.get('transaction_id');

    if (!transactionId || !urlPaymentMethod) {
      setStatus('error');
      setMessage('Invalid payment session');
      return;
    }

    const checkStatus = async () => {
      try {
        const { message: responseMessage, paymentData } = await checkPaymentStatus(
          transactionId,
          urlPaymentMethod,
          urlPaymentStatus,
        );
        setMessage(responseMessage);

        console.log(message);
        console.log(paymentData);

        switch (paymentData?.status) {
          case 'COMPLETED':
            setStatus('success');
            setError(null);
            break;
          case 'FAILED':
            setStatus('error');
            setError('Payment verification failed');
            break;
          default:
            setStatus('processing');
            setError(null);
        }
      } catch (err) {
        console.log('Catch ', err);

        setStatus('error');
        setMessage('Unable to process payment');
        setError(err?.message);
      }
    };

    checkStatus();
  }, [location.search]);

  const getStatusIcon = () => {
    switch (status) {
      case 'success':
        return <CheckCircleOutlined />;
      case 'error':
        return <CloseCircleOutlined />;
      case 'processing':
        return <LoadingOutlined spin />;
      default:
        return null;
    }
  };

  const handleAction = () => {
    if (status === 'success') {
      navigate('/dashboard');
    } else {
      navigate('/payment');
    }
  };

  const getStatusTitle = () => {
    switch (status) {
      case 'success':
        return 'Payment Successful';
      case 'error':
        return 'Payment Failed';
      default:
        return 'Processing Payment';
    }
  };

  return (
    <PaymentStatusWrapper>
      <StatusIcon status={status}>{getStatusIcon()}</StatusIcon>
      <StatusTitle>{getStatusTitle()}</StatusTitle>
      <StatusMessage>{message}</StatusMessage>

      {error && (
        <ErrorDetails>
          <p>Error Details: {error}</p>
        </ErrorDetails>
      )}

      <ActionButton onClick={handleAction}>{status === 'success' ? 'Go to Dashboard' : 'Try Again'}</ActionButton>
    </PaymentStatusWrapper>
  );
}

export default PaymentStatus;
